import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_GET_CAMPAIGN_SUMMARY_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetCampaignSummary = (campaignId?: number | string) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)

  const res = esApi.endpoints.getCampaignSummary.useQuery(
    {
      orgId: orgId?.toString(),
      campaignId: String(campaignId),
    },
    { skip: !orgId || !campaignId },
  )

  const { error } = res
  useEffect(() => {
    if (!error) {
      return
    }

    dispatch(
      createNotification({
        'get-campaign-summary-failure': {
          type: 'error',
          message: getErrorMessage(error, ERROR_GET_CAMPAIGN_SUMMARY_SERVER),
        },
      }),
    )
  }, [error, dispatch])

  return res
}
